import HowScoreIsCalculated from "./HowScoreIsCalculated";

export default HowScoreIsCalculated;
